// src/components/AppDownloadSection.js
import React from 'react';
import './AppDownloadSection.css';

// TODO: Replace with your actual image imports
import appStore from '../assets/app-store.png';
import googlePlay from '../assets/google-play.png';

const AppDownloadSection = () => {
  return (
    <section className="app-download-section">
      <div className="">
        <h3>Our services can be booked using our App Download <span className='main-highlight'> Doodley</span> App Now</h3>
        {/* <h2>Download The <span className="highlight">Doodley</span> App Now</h2> */}
        <div className="app-buttons">
          <a target='_blank' rel="noreferrer"  href="https://apps.apple.com/in/app/doodley/id6472489290"><img src={appStore} alt="Play Store" /></a>
          <a target='_blank' rel="noreferrer" href="https://play.google.com/store/apps/details?id=com.doodleyclient"><img src={googlePlay} alt="App Store" /></a>
        </div>
      </div>
    </section>
  );
};

export default AppDownloadSection;